<!--~
~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
~ to an End-User License Agreement included in a separate file named EULA.txt
~ that is distributed with this file.
-->
@if (fileHash) {
  <div class="avoid-break" fxLayout="row" fxLayoutAlign="start center">
    @if ((fileType$|async) === 'image') {
      <img (click)="download()"
        (load)="imageLoaded()"
        [src]="thumbnailUrl$|async"
        alt="Image Thumbnail"/>
    } @else {
      <button mat-icon-button (click)="download()" matTooltip='Download'>
        <mat-icon [svgIcon]="icon$|async"></mat-icon>
      </button>
    }
    @if (dataForm !== '') {
      <button mat-icon-button matTooltip='Remove file' aria-label="remove" (click)="confirmRemove()">
        <mat-icon svgIcon="trash" aria-label="Remove"></mat-icon>
      </button>
    }
  </div>
}


